"use client";

import moment from "moment";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {  uid } from "../utils/utils";
import { Patient, Reference } from "../data/allTypes";
import { getStandardDeviation } from "../data/pediatricsChartData";

export type ChartPropertiesType = {
  color?: string;
  strokeWidth?: number;
  dot?: boolean;
  strokeDasharray?: string;
  showFill?: boolean;
  bold?: boolean;
};

export function PediatricsRechartChart({
  chartData,
  patient,
  reference,
  chartsProperties,
}: {
  chartData: Record<string, { x: any; y: any }[]>;
  patient: Patient;
  reference: Reference;
  chartsProperties: Record<string, ChartPropertiesType>;
}) {
  console.log("chartData", chartData);

  function generateFlatChartData(
    chartData: Record<string, { x: any; y: any }[]>
  ) {
    const dataObj: { [x: number]: { [chartName: string]: number | null } } = {};
    const allChartNames = [];
    for (let [chartName, chartItems] of Object.entries(chartData)) {
      allChartNames.push(chartName);
    }

    for (let [chartName, chartItems] of Object.entries(chartData)) {
      for (let item of chartItems) {
        let x = item.x;
        let y = item.y;
        dataObj[x] ||= {
          x,
          y,
        };
        if ((dataObj[x].y || 0) <= (y || 0)) dataObj[x].y = y || 0;
        dataObj[x][chartName] = y;
      }
    }
    console.log("dataObj", { dataObj, values: Object.values(dataObj) });
    return Object.values(dataObj);
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        accessibilityLayer
        data={generateFlatChartData(chartData)}
        margin={{
          left: 12,
          right: 12,
        }}
      >
        <CartesianGrid
          vertical={true}
          horizontal={true}
          strokeDasharray="3 3"
        />
        <XAxis
          dataKey="x"
          type="number"
          tickLine={false}
          axisLine={false}
          tickCount={16}
          tickFormatter={(value) => {
            return moment()
              .add(value, "months")
              .diff(moment(), "years")
              .toString();
          }}
        />
        <YAxis dataKey="y" />

        {Object.entries(chartData).map(([chartName, chartItems]) => {
          const { color, strokeWidth, dot, strokeDasharray, showFill, bold } =
            chartsProperties[chartName] || {};
          return (
            <>
              <defs>
                <linearGradient
                  id={`fill${chartName}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color || "red"}
                    stopOpacity={0.7}
                  />
                  <stop
                    offset="95%"
                    stopColor={color || "red"}
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>
              <Area
                key={chartName}
                dataKey={chartName}
                type="monotone"
                strokeDasharray={strokeDasharray}
                fill={showFill ? `url(#fill${chartName})` : "transparent"}
                connectNulls={true}
                strokeWidth={strokeWidth || 1}
                dot={dot || false}
                fillOpacity={0.4}
                stroke={color || "red"}
                stackId={chartName}
                isAnimationActive={true}
              />
            </>
          );
        })}
        <Tooltip
          content={(val) => {
            let items = val.payload?.filter(
              (p) =>
                !p.name?.toString()?.includes("+") &&
                !p.name?.toString()?.includes("-") &&
                !p.name?.toString()?.includes("mediane")
            );
            if (items?.length == 0) return null;

            console.log("theeee val", val.payload);

            return (
              <div
                className="white br bs p10 c1 gap5"
                style={{ background: "white" }}
              >
                {items
                  ?.sort(
                    (a, b) =>
                      parseFloat(b.value?.toString() || "0") -
                      parseFloat(a.value?.toString() || "0")
                  )
                  .map((p) => {
                    return (
                      <div key={uid()} className="c2 gap10">
                        <div className="bold" style={{ color: p.color }}>
                          {p.name}{" "}
                        </div>
                        <div
                          className="gray normal"
                          style={{
                            color: p.color || undefined,
                            fontWeight:
                              (parseInt(p.strokeWidth?.toString() || "0") ||
                                0) > 2
                                ? "bold"
                                : undefined,
                          }}
                        >
                          {p.value} <span className="black normal">(
                          {getStandardDeviation({
                            value: parseFloat(p.value?.toString() || "0"),
                            reference: reference,
                            date: p.payload?.toString() || "",
                            patient: patient,
                          })}
                          {" "}sd)</span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            );
          }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
